import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getLegacyRedirectUrl } from 'actions/authentication';

const LegacyRedirect = () => (
  <div className="page-content">
    <div className="container txt-center">
      <span className="icon icon--heart" />
      <FormattedMessage id="redirect.legacy.title" tagName="h1" />
      <FormattedMessage id="redirect.legacy.text" tagName="p" />
      <br />
      <br />
      <a className="btn" href={getLegacyRedirectUrl()}>
        <FormattedMessage id="redirect.legacy.button" />
      </a>
    </div>
  </div>
);

export default LegacyRedirect;
